import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Tooltip, Table, LoadingIndicator } from '@components';
import { useSelector } from 'react-redux';
import { ResgateParcialService } from '@services';
import { format } from 'date-fns';
import {
  gerarComprovamenteResgateParcialPDF,
  gerarMemoriaCalculoResgateParcialPDF,
} from '../utils/resgate-parcial';

const formatarDataPagamento = (dataPagamento) => {
  if (!dataPagamento) return '';
  const data = new Date(dataPagamento);
  if (Number.isNaN(data.getTime())) return dataPagamento;
  return format(data, 'dd/MM/yyyy');
};

const obterAnoMesPagamento = (dataPagamento) => {
  if (!dataPagamento) return '';
  const data = new Date(dataPagamento);
  if (Number.isNaN(data.getTime())) return dataPagamento;
  return format(data, 'yyyyMM');
};

export const HistoricoResgateParcial = () => {
  const { matricula, plano, token } = useSelector((state) => state.user.data);
  const { nome } = useSelector((state) => state.user.dadosPessoais);
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);

  const obterHistoricoResgateParcial = useCallback(async () => {
    setLoading(true);
    const service = new ResgateParcialService();
    setHistorico(await service.ObterHistoricoResgateParcial(matricula, plano));
    setLoading(false);
  }, [matricula, plano]);

  useEffect(() => {
    obterHistoricoResgateParcial();
  }, [obterHistoricoResgateParcial]);

  return !loading ? (
    <>
      <Helmet>
        <title>Histórico de Pedidos de Resgate Parcial</title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <span className="fw-bold ts-10 mb-32 mb-md-5">
            Histórico de Pedidos de Resgate Parcial
            <Tooltip title="Veja o histórico de Pedidos de Resgate Parcial">
              ?
            </Tooltip>
          </span>
          <Table
            className=" mb-4 mt-32"
            odd
            columns={[
              'Protocolo',
              'Data Solicitação',
              'Percentual resgatado do saldo',
              // 'Percentual remanescente Parcela à vista',
              'Previsão de crédito',
              'Termo opção',
              'Memória de cálculo',
              'Status',
            ]}
          >
            {historico.map((linha) => {
              const percentualResgatado = String(
                linha.PercentualResgatado ?? ''
              ).replace(',', '.');
              return (
                <tr key={linha.Protocolo}>
                  <td>{linha.Protocolo}</td>
                  <td>{linha.DataPedido}</td>
                  <td>
                    {Number(percentualResgatado) && linha.Status !== 'Cancelada'
                      ? `${linha.PercentualResgatado}%`
                      : '-'}
                  </td>
                  <td>{formatarDataPagamento(linha.DataPagamento)}</td>
                  <td>
                    {linha.Status !== 'Cancelada' ? (
                      <button
                        className="btn link"
                        onClick={() =>
                          gerarComprovamenteResgateParcialPDF({
                            registroResgate: linha,
                            nome,
                            plano,
                            token,
                            matricula,
                          })
                        }
                      >
                        <p>Baixar Termo</p>
                      </button>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {linha.DataPagamento ? (
                      <button
                        className="btn link"
                        onClick={() =>
                          gerarMemoriaCalculoResgateParcialPDF(
                            matricula,
                            obterAnoMesPagamento(linha.DataPagamento),
                            token
                          )
                        }
                      >
                        <p>Baixar Memória de cálculo</p>
                      </button>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <b>{linha.Status}</b>
                  </td>
                </tr>
              );
            })}
          </Table>
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
